import React from 'react';
import classnames from 'classnames';
import SuccessIcon from '../../Icons/Success';
import { IconSize } from '../../Icons/IconWrap';
import s from './InputLayout.scss';
const bindOwnClassnamesWithSkin = (ownClassMapping, skinClassMapping)=>{
    return (...classnamesList)=>{
        const ownClassnames = classnamesList.map((classname)=>ownClassMapping[classname]);
        const skinClassnames = classnamesList.map((classname)=>skinClassMapping[classname]);
        return classnames(...ownClassnames, ...skinClassnames);
    };
};
const InputLayout = ({ children, className, textUnderClassName, labelClassName, fullWidth, fullHeight, label, id, isFilled, isFocused, hasPlaceholder, hasError, readOnly, success, loading, hint, prefixIcon: PrefixIcon, withFadedPrefixIcon, suffix, errorMessage, showHintOnFocus, withPaddings = true, withBar = true, skin, onClick })=>{
    const classes = bindOwnClassnamesWithSkin(s, skin || {});
    const renderLabel = ()=>{
        if (!label) {
            return null;
        }
        return /*#__PURE__*/ React.createElement("label", {
            htmlFor: id,
            className: classnames(classes('label'), labelClassName)
        }, label);
    };
    const renderPrefix = ()=>{
        if (!PrefixIcon) {
            return null;
        }
        return /*#__PURE__*/ React.createElement(PrefixIcon, {
            className: classnames(classes('prefix-icon'), withFadedPrefixIcon && classes('faded'))
        });
    };
    const renderSuffix = ()=>{
        const suffixChildren = [];
        if (suffix) {
            suffixChildren.push(suffix);
        }
        if (success) {
            suffixChildren.push(/*#__PURE__*/ React.createElement(SuccessIcon, {
                size: IconSize.TINY
            }));
        }
        if (!suffixChildren.length) {
            return null;
        }
        return /*#__PURE__*/ React.createElement("div", {
            className: classes('suffix')
        }, React.Children.toArray(suffixChildren));
    };
    const renderTextUnder = ()=>{
        let textUnder;
        if (hint && (!showHintOnFocus || isFocused)) {
            textUnder = /*#__PURE__*/ React.createElement("span", {
                className: classes('hint-under')
            }, hint);
        }
        if (errorMessage) {
            textUnder = /*#__PURE__*/ React.createElement("span", {
                className: classes('error-under')
            }, errorMessage);
        }
        if (!textUnder) {
            return null;
        }
        return /*#__PURE__*/ React.createElement("div", {
            onClick: onTextUnderClick,
            className: classnames(textUnderClassName, classes('text-under'))
        }, textUnder);
    };
    const onTextUnderClick = (e)=>{
        // clicking text under should not trigger onClick event -- it's not the control element
        e.stopPropagation();
    };
    return /*#__PURE__*/ React.createElement("div", {
        className: classnames(classes('root'), withPaddings && classes('input-layout-paddings'), fullWidth && s['full-width'], s['updated-inputs'], className)
    }, /*#__PURE__*/ React.createElement("div", {
        className: classes('input-layout-content', isFocused && 'focused', isFilled && 'filled', hasPlaceholder && 'has-placeholder', PrefixIcon && 'has-prefix-icon', hasError && 'has-error', success && 'success', loading && 'loading', readOnly && 'read-only', fullHeight && 'full-height'),
        onClick: onClick
    }, renderLabel(), /*#__PURE__*/ React.createElement("div", {
        className: classes('input-wrapper')
    }, renderPrefix(), children, renderSuffix()), withBar && /*#__PURE__*/ React.createElement("div", {
        className: classes('bar')
    }), renderTextUnder()));
};
export default InputLayout;
